import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import GetAppIcon from '@mui/icons-material/GetApp'
import AutoComplete from '../../../AutoComplete'
import SearchIcon from '@mui/icons-material/Search'

import Dialog from '../../../../components/ModalDialog'
import Filter from './Filters'
import moment from 'moment'
import { Button, CircularProgress, DialogActions } from '@mui/material'

export default function SearchDownloadMultipleDocument({
  open,
  title,
  iconTitle,
  placeholderInput,
  onSearch,
  isLoading,
  options,
  countOptions,
  onSearchMore,
  sxInput,
  downloadDocument,
  handleClose,
  isFilter,
  isGenerationTournee,
  isLoadingDownloadTournee,
  isLoadingDownloadRetours,
}) {
  const [filtersValues, setFilters] = useState({})

  const [select, setSelect] = useState(false)
  const [valueSelect, setValueSelect] = useState([])
  const [search, setSearch] = useState('')
  const [offset, setOffset] = useState(25)
  const ALL_LYON_ITEMS = [
    { id: 'NA WG1', label: 'NA WG1' },
    { id: 'NA WG2', label: 'NA WG2' },
    { id: 'NA WG3', label: 'NA WG3' },
    { id: 'NA WG4', label: 'NA WG4' },
    { id: 'NA WG6', label: 'NA WG6' },
    { id: 'LY MCT', label: 'LY MCT' },
    { id: 'NA JUR', label: 'NA JUR' },
    { id: 'LY GT2', label: 'LY GT2' },
    { id: 'LY T25', label: 'LY T25' },
    { id: 'LY CNS', label: 'LY CNS' },
    { id: 'LY T71', label: 'LY T71' },
    { id: 'LY TTS', label: 'LY TTS' },
    { id: 'LY T73', label: 'LY T73' },
    { id: 'LY ISE', label: 'LY ISE' },
    { id: 'LY COT', label: 'LY COT' },
    { id: 'LY W63', label: 'LY W63' },
    { id: 'LY W43', label: 'LY W43' },
    { id: 'LY SUD', label: 'LY SUD' },
  ]
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (search.length > 0 && !select) {
        const filter = {
          limit: 25,
          offset: 0,
          query: search.trim().toUpperCase(),
        }
        onSearch(filter)
      } else if (search == '') {
        const filter = {
          limit: 25,
          offset: 0,
        }
        onSearch(filter)
      }
      setOffset(25)
    }, 500)

    return () => clearTimeout(delayDebounceFn)
  }, [search])

  const onChangeSearch = (value) => {
    setSelect(false)
    if (value) {
      let val = value
      setSearch(val)
    } else {
      setSearch('')
    }
  }

  const onSelect = (value) => {
    if (value) {
      const hasAllLyon = value.some((el) => el.id == 'ALL_LYON')
      if (hasAllLyon) {
        const filtered = value.filter((el) => el.id !== 'ALL_LYON')

        value = [...filtered, ...ALL_LYON_ITEMS]
      }

      setValueSelect(value)
      setSelect(value.length > 0)
    }
  }

  const loadMore = (event) => {
    if (
      Math.round(event.target.scrollHeight - event.target.scrollTop) ==
        event.target.clientHeight &&
      countOptions >= offset
    ) {
      setOffset(offset + 25)
      const filter = {
        limit: 25,
        offset: offset,
        query: search.length > 0 ? search.trim().toUpperCase() : undefined,
      }
      onSearchMore(filter)
    }
  }

  return (
    <Dialog
      maxWidthDialog={'md'}
      open={open}
      title={title}
      iconTitle={iconTitle}
      fullWidth={true}
      content={
        <div
          style={{
            padding: '0px 16px 16px 0px',
          }}
        >
          {isFilter && <Filter setFilters={setFilters} filters={filtersValues} />}

          <div
            style={{
              backgroundColor: 'white',
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
              padding: '0px 16px 16px 0px',
              borderRadius: '5px',
            }}
          >
            <div style={{ width: select && !isGenerationTournee ? '91%' : '100%' }}>
              <AutoComplete
                freeSolo
                value={valueSelect}
                name={'search-multiple'}
                onChange={(event, value) => {
                  onSelect(value)
                }}
                onInputChange={(event, value) => onChangeSearch(value)}
                id="Search-Multiple"
                options={options}
                isOptionEqualToValue={(option, value) =>
                  option.label === value.label
                }
                variant="outlined"
                placeholder={placeholderInput}
                sxInputStyle={sxInput}
                multiple={true}
                fullWidth={true}
                ListboxProps={{
                  onScroll: loadMore,
                }}
                loading={isLoading}
                inputValue={search}
                startIcon={
                  <SearchIcon
                    sx={{
                      paddingRight: '4px',
                      width: '26px !important',
                      height: '26px !important',
                      color: '#C2C2C2 !important',
                    }}
                  />
                }
              />
            </div>
            {select && !isGenerationTournee && (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <GetAppIcon
                  onClick={() =>
                    downloadDocument(
                      valueSelect.map((value) => value.id).join(','),
                      filtersValues?.dateLivraison ||
                        moment(new Date()).format('DD-MM-YYYY')
                    )
                  }
                  style={{ cursor: 'pointer', fontSize: '30px' }}
                />
              </div>
            )}
          </div>
          {select && isGenerationTournee && (
            <DialogActions>
              {isLoadingDownloadRetours ? (
                <div
                  style={{
                    display: 'inline-flex',
                    verticalAlign: 'middle',
                    justifyContent: 'center',
                    width: '159px',
                    paddingTop: '6px',
                  }}
                >
                  <CircularProgress
                    color="primary"
                    style={{ width: '30px', height: '30px' }}
                  />
                </div>
              ) : (
                <Button
                  id={'download-retours'}
                  variant={'contained'}
                  onClick={() =>
                    downloadDocument(
                      valueSelect.map((value) => value.id).join(','),
                      filtersValues?.dateLivraison ||
                        moment(new Date()).format('DD-MM-YYYY'),
                      true
                    )
                  }
                  sx={{
                    '&.MuiButton-root': {
                      marginLeft: '15px',
                      marginRight: '12px',
                      textTransform: 'none ',
                      fontSize: '13px ',
                      backgroundColor: 'white',
                      color: '#1976d2',
                      border: '1px solid #1976d2',
                      boxShadow: 'none',
                      ':hover': {
                        backgroundColor: 'white',
                        border: '1px solid #0a4783',
                        color: '#0a4783',
                      },
                    },
                    '&.Mui-disabled': {
                      color: 'rgba(0, 0, 0, 0.26) !important',
                      backgroundColor: 'rgba(0, 0, 0, 0.12) !important',
                      border: '1px solid rgba(0, 0, 0, 0.12)',
                    },
                  }}
                >
                  {'Télécharger Retours'}
                </Button>
              )}
              {isLoadingDownloadTournee ? (
                <div
                  style={{
                    display: 'inline-flex',
                    verticalAlign: 'middle',
                    justifyContent: 'center',
                    width: '159px',
                  }}
                >
                  <CircularProgress
                    color="primary"
                    style={{ width: '30px', height: '30px' }}
                  />
                </div>
              ) : (
                <Button
                  id={'button-tournee'}
                  variant={'contained'}
                  sx={{
                    textTransform: 'none ',
                    fontSize: '13px ',
                    fontWeight: '400 ',
                    backgroundColor: '#1976d2',
                    ':hover': {
                      backgroundColor: '#0a4783',
                    },
                  }}
                  onClick={() =>
                    downloadDocument(
                      valueSelect.map((value) => value.id).join(','),
                      filtersValues?.dateLivraison ||
                        moment(new Date()).format('DD-MM-YYYY'),
                      false
                    )
                  }
                >
                  {'Télécharger Tournée'}
                </Button>
              )}
            </DialogActions>
          )}
        </div>
      }
      handleClose={handleClose}
      isClosedIcon={true}
    />
  )
}

SearchDownloadMultipleDocument.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  iconTitle: PropTypes.any,
  placeholderInput: PropTypes.string,
  onSearch: PropTypes.func,
  isLoading: PropTypes.bool,
  options: PropTypes.array,
  countOptions: PropTypes.number,
  onSearchMore: PropTypes.func,
  sxInput: PropTypes.object,
  downloadDocument: PropTypes.func,
  handleClose: PropTypes.func,
  isFilter: PropTypes.bool,
  isGenerationTournee: PropTypes.bool,
  isLoadingDownloadTournee: PropTypes.bool,
  isLoadingDownloadRetours: PropTypes.bool,
}
